import { animate, style, transition, state, trigger } from '@angular/animations';

export const slideInAndOut =
  trigger('slideInAndOut', [
    state('in', style({ transform: 'translateY(0)' })),
    transition('void => *', [
      style({ transform: 'translateY(-100%)' }),
      animate('200ms cubic-bezier(0.35, 0, 0.25, 1)')
    ]),
    transition('* => void', [
      animate(100, style({ transform: 'translateY(100%)' }))
    ])
  ]);
